import React from 'react';
import { Portal } from 'react-portal';
import { CSSTransition } from 'react-transition-group';
import styled from 'styled-components';
import { COLOR, SIZE } from '../../styles';
import { type BannerProps } from './Banner.types';

const Banner: React.FC<BannerProps> = (props) => {
  const { className = '', show, text } = props;

  return (
    <Portal>
      <CSSTransition
        //The animation classNames applied to the component as it appears, enters, exits or has finished the transition.
        //A single name can be provided, which will be suffixed for each stage
        classNames="app-banner-wrap"
        in={show}
        timeout={{ exit: 300, enter: 1000 }}
        unmountOnExit
      >
        <BannerWrap className={`app-banner-wrap ${className}`} data-testid="banner-wrapper">
          <BannerText className="app-banner" data-testid="banner-text">
            {text}
          </BannerText>
        </BannerWrap>
      </CSSTransition>
    </Portal>
  );
};
// Styled Components
const BannerWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;

  &.app-banner-wrap-enter {
    opacity: 1;
    transform: translate(0, -30px);

    &.app-banner-wrap-enter-active {
      opacity: 1;
      transform: translate(0, 0px);
      transition: all 500ms ease-in;
    }
  }

  .app-banner-wrap-appear {
    opacity: 0;
    transform: translate(0, -30px);

    &.app-banner-wrap-appear-active {
      opacity: 1;
      transform: translate(0, 0px);
      transition: all 500ms ease-in;
    }
  }

  .app-banner-wrap-leave {
    opacity: 1;
    transform: translate(0, 0px);

    &.app-banner-wrap-leave-active {
      opacity: 0;
      transform: translate(0, -30px);
      transition: all 500ms ease-in;
    }
  }
`;

const BannerText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  position: absolute;
  height: auto;
  background-color: ${COLOR['turquoise-dark']};
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  color: ${COLOR['white']};
  font-size: 14px;
  padding: 8px ${SIZE['16']};
  top: 0;
  line-height: 1.3;
  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.3);
`;

// Display Name
Banner.displayName = 'Banner';

export default Banner;
